import axios from 'axios';
import {backendHost} from '../../config';

export const putChangeStatusPaymentsMethod = (params) => {
    return axios.put(`${backendHost}/api/partners/admin/wallet/change-status`, params);
};